import { ITabsData, TabContainerStickyClassActions, TabsState } from './types';

let currentDiffScroll = 0;

export const CalculateTabsValues = (tabsData: ITabsData) => {
  const changeTabContainerStickyClass = (action: TabContainerStickyClassActions, className: string) =>
    tabsData.tabContainerRef.classList[action](className);
  const setTabSectionsProperWidth = () =>
    (tabsData.tabContainerRef.style.width = tabsData.tabSectionsRef?.$el.offsetWidth + 'px');

  const statePosition = () => {
    if (!tabsData?.tabWrapperRef) return TabsState.stuck;

    const { position } = window.getComputedStyle(tabsData.tabContainerRef);

    currentDiffScroll =
      tabsData.tabContainerRef.offsetTop > 0 && position !== 'absolute'
        ? tabsData.tabContainerRef.offsetTop
        : currentDiffScroll;

    const topParentOffset = tabsData.tabWrapperRef.getBoundingClientRect().top;
    const topParentOffsetFromPage = topParentOffset + currentDiffScroll + window.scrollY;

    const containerBottom = topParentOffsetFromPage + tabsData.tabSectionsRef?.$el.offsetHeight;

    if (window.scrollY < topParentOffsetFromPage) return TabsState.base;
    if (window.scrollY < containerBottom) return TabsState.sticky;

    return TabsState.stuck;
  };

  return {
    changeTabContainerStickyClass,
    setTabSectionsProperWidth,
    statePosition,
  };
};
